import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import CloseButton from 'components/Common/CloseButton'
import SlideDown from 'components/Common/SlideDown'
import AnimateHeight from 'react-animate-height'

const Root = styled.section`
  position: relative;
  border-top: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
`

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: ${rem(8)};
  right: ${rem(8)};
  z-index: 1;
`

interface Props {
  className?: string;
  isOpen: boolean;
  onToggle?: () => void;
  children: any;
  onAnimationEnd?: () => void;
}

const PaneDetailsSection = React.forwardRef<AnimateHeight, Props>(
  ({ className, isOpen, onToggle, children, onAnimationEnd }: Props, ref) => (
    <SlideDown onAnimationEnd={onAnimationEnd} show={isOpen} ref={ref}>
      <Root className={className}>
        {onToggle &&
          <StyledCloseButton onClick={onToggle} />
        }
        {children}
      </Root>
    </SlideDown>
  ))

export default PaneDetailsSection
